import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Avatar from './Avatar';
import { getAppChannelDetails, hasChannels } from '../utils/app';
import { showChannelPage, showSettings } from '../actions/app-state';

export class ConnectNotificationComponent extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        appChannels: PropTypes.array.isRequired,
        config: PropTypes.object.isRequired,
        connectNotificationText: PropTypes.string.isRequired,
        connectNotificationSingleButtonText: PropTypes.string.isRequired,
        connectNotificationSingleText: PropTypes.string.isRequired,
        connectNotificationOthersText: PropTypes.string.isRequired,
        prechatCaptureMailgunLinkingConfirmation: PropTypes.string.isRequired,
        completedPrechatCaptureLinking: PropTypes.bool.isRequired,
        clients: PropTypes.array.isRequired,
    };

    render() {
        const {
            appChannels,
            connectNotificationText,
            connectNotificationSingleButtonText,
            connectNotificationSingleText,
            connectNotificationOthersText,
            completedPrechatCaptureLinking,
            prechatCaptureMailgunLinkingConfirmation,
            config,
            clients,
            dispatch,
        } = this.props;

        const isConnectNotification = hasChannels(config);
        const channels =
            isConnectNotification &&
            getAppChannelDetails(appChannels, config.integrationOrder).filter(({ details }) => details.isLinkable);

        const notificationClasses = ['connect-notification'];

        let notificationText = connectNotificationText;

        if (isConnectNotification && channels && channels.length > 0) {
            // If 4 channels, render all 4, otherwise pick the 3 first ones and generate
            // a X more button.
            const renderedChannels = channels.length <= 4 ? channels : channels.slice(0, 3);

            let renderedItems;

            if (renderedChannels.length === 1) {
                const { channel, details } = channels[0];
                const buttonStyle = {
                    borderColor: `#${config.colors.linkColor}`,
                    backgroundColor: `#${config.colors.linkColor}`,
                };

                const onClick = (e) => {
                    e.preventDefault();
                    dispatch(showChannelPage(channel.category));
                };

                renderedItems = (
                    <button className="btn btn-primary" onClick={onClick} style={buttonStyle}>
                        {connectNotificationSingleButtonText.replace('<name>', details.shortName)}
                    </button>
                );

                notificationText = connectNotificationSingleText;
            } else {
                renderedItems = renderedChannels.map(({ channel, details }) => {
                    const onClick = (e) => {
                        e.preventDefault();
                        dispatch(showChannelPage(channel.category));
                    };

                    return (
                        <div className="connect-notification-icon" onClick={onClick} key={channel.type}>
                            <img src={details.svg} alt={details.name} />
                            <span>{details.shortName}</span>
                        </div>
                    );
                });

                const extraChannelsCount = channels.length - renderedChannels.length;
                if (extraChannelsCount > 0) {
                    const onExtraClick = (e) => {
                        e.preventDefault();
                        dispatch(showSettings());
                    };
                    renderedItems.push(
                        <div className="connect-notification-icon extra-count" onClick={onExtraClick} key="settings">
                            <div className="count">{`+${extraChannelsCount}`}</div>
                            <span>{connectNotificationOthersText}</span>
                        </div>,
                    );
                }
            }

            if (completedPrechatCaptureLinking) {
                const mailgunClient = clients.find(({ platform }) => platform === 'mailgun');
                if (mailgunClient) {
                    const [textFirstPart, textLastPart] = prechatCaptureMailgunLinkingConfirmation.split('{email}');

                    notificationClasses.push('connect-notification-linking-message');

                    notificationText = (
                        <span>
                            {textFirstPart} <b>{mailgunClient.displayName}</b> {textLastPart}
                        </span>
                    );
                    renderedItems = [];
                }
            }

            return (
                <div className="row left-row">
                    <div className="msg-wrapper">
                        {config.businessIconUrl ? (
                            <Avatar avatarUrl={config.businessIconUrl} />
                        ) : (
                            <div className="msg-avatar-placeholder" />
                        )}
                        <div className={notificationClasses.join(' ')}>
                            <p>{notificationText}</p>
                            <div className="connect-notification-channels">{renderedItems}</div>
                        </div>
                    </div>
                </div>
            );
        }

        return null;
    }
}

export default connect(
    ({ config, ui: { text }, conversations, appState: { activeConversationId }, user: { clients = [] } }) => {
        const conversation = conversations[activeConversationId];
        const { completedPrechatCaptureLinking = false } = conversation;

        return {
            appChannels: config.integrations,
            connectNotificationText: text.connectNotificationText,
            connectNotificationSingleButtonText: text.connectNotificationSingleButtonText,
            connectNotificationSingleText: text.connectNotificationSingleText,
            connectNotificationOthersText: text.connectNotificationOthersText,
            prechatCaptureMailgunLinkingConfirmation: text.prechatCaptureMailgunLinkingConfirmation,
            completedPrechatCaptureLinking,
            clients,
            config,
        };
    },
    null,
    null,
    { forwardRef: true },
)(ConnectNotificationComponent);
